/* El Ropero de la Anita — ajustes visuales del carrito, sin modificar el checkout nativo */
(function(){
'use strict';
if(!document.querySelector('cart-items'))return;
document.body.classList.add('anita-cart-page');
if(document.getElementById('preview-bar-iframe')||document.querySelector('iframe[src*="preview-bar"]'))document.body.classList.add('anita-cart-preview');
var goal=4999000,shipping=document.querySelector('[data-anita-cart-shipping]');
var money=function(n){return '$'+Math.max(0,Math.round(n/100)).toLocaleString('es-CL');};
var normalize=function(s){return String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');};
var tones=[
 [/azul\s+marino|navy/,'Azul marino','#182F54','azul'],
 [/azul\s+oscuro/,'Azul oscuro','#283C67','azul'],
 [/turquesa/,'Turquesa','#44ADB9','turquesa'],
 [/celeste/,'Celeste','#91D0ED','celeste'],
 [/gris\s+claro/,'Gris claro','#AEB3BA','gris'],
 [/gris\s+oscuro|grafito/,'Gris oscuro','#50555C','gris'],
 [/gris\s+jaspeado/,'Gris jaspeado','#8C939B','gris'],
 [/verde\s+oliva/,'Verde oliva','#777D4B','verde'],
 [/verde\s+musgo/,'Verde musgo','#647653','verde'],
 [/blanco|blanca/,'Blanco','#FFFFFF','blanco'],
 [/negro|negra/,'Negro','#1C1E23','negro'],
 [/beige/,'Beige','#CDBB9C','beige'],
 [/crema|marfil/,'Crema','#EDE0CD','crema'],
 [/cafe|marron/,'Café','#79553D','cafe'],
 [/burdeo|borgona|vino/,'Burdeo','#793648','burdeo'],
 [/fucsia/,'Fucsia','#DE2481','fucsia'],
 [/rosado|rosada|rosa/,'Rosado','#E9A7B8','rosado'],
 [/rojo|roja/,'Rojo','#CD3640','rojo'],
 [/naranja|naranjo|coral/,'Naranja','#EA834A','naranja'],
 [/mostaza/,'Mostaza','#C9A04A','mostaza'],
 [/amarillo|amarilla/,'Amarillo','#E4CA4C','amarillo'],
 [/morado|morada|violeta/,'Morado','#80599E','morado'],
 [/lila/,'Lila','#AA93D2','lila'],
 [/gris/,'Gris','#8A9096','gris'],
 [/azul/,'Azul','#3A67B6','azul'],
 [/verde/,'Verde','#4C8B68','verde']
];
function findColors(source){
 var s=normalize(source),hits=[],groups={};
 tones.forEach(function(x,i){var m=s.match(x[0]);if(m&&!groups[x[3]]){groups[x[3]]=true;hits.push({index:m.index,rank:i,name:x[1],hex:x[2]});}});
 return hits.sort(function(a,b){return a.index-b.index||a.rank-b.rank;}).slice(0,3);
}
function makeMeta(row){
 if(row.querySelector('.anita-cart-item-meta'))return;
 var name=row.querySelector('.cart-item__name'),details=row.querySelector('.cart-item__details');
 if(!name||!details)return;
 var orig=name.textContent.replace(/\s+/g,' ').trim();
 var match=orig.match(/\bTALLA\s+(\d{1,3}X|[A-Z]{1,4}\d?|\d{1,3}(?:\s*\/\s*\d{1,3})?)(?:\s*\(\s*\d{1,2}\s*\/\s*\d{1,2}\s*\))?/i);
 var size=match?match[1]:(row.dataset.anitaCartSize||'').replace(/\s*\(.+$/,'').trim();
 if(match){var clean=orig.replace(match[0],'').replace(/[\s·|,\-–]+$/,'').trim();if(clean.length>6)name.textContent=clean;}
 var text=row.dataset.anitaCartColor||'';
 if(!text)text=row.dataset.anitaCartIntro||'';
 if(!text)text=orig;
 var colors=findColors(text);
 if(!size&&!colors.length)return;
 var meta=document.createElement('div');meta.className='anita-cart-item-meta';
 if(size){var chip=document.createElement('span');chip.className='anita-cart-item-meta__size';chip.textContent='Talla '+size;meta.appendChild(chip);}
 if(colors.length){
  var color=document.createElement('span'),dot=document.createElement('span'),label=document.createElement('span');
  color.className='anita-cart-item-meta__color';dot.className='anita-cart-item-meta__dot';dot.setAttribute('aria-hidden','true');
  dot.style.background=colors.length===1?colors[0].hex:'conic-gradient('+colors.map(function(c,i){return c.hex+' '+(i*100/colors.length)+'% '+((i+1)*100/colors.length)+'%';}).join(',')+')';
  label.textContent=colors.map(function(x){return x.name;}).join(' / ');color.append(dot,label);meta.appendChild(color);
 }
 name.insertAdjacentElement('afterend',meta);
}
function updateProgress(total,count){
 if(!shipping)return;
 if(typeof total!=='number'||!isFinite(total))return;
 var remaining=Math.max(0,goal-total),percent=Math.round(Math.min(100,total/goal*100));
 var value=shipping.querySelector('[data-anita-remaining]');
 var detail=shipping.querySelector('[data-anita-shipping-detail]');
 var track=shipping.querySelector('[data-anita-progress]');
 var fill=shipping.querySelector('[data-anita-fill]');
 if(fill)fill.style.width=percent+'%';
 if(track)track.setAttribute('aria-valuenow',String(percent));
 if(value)value.textContent=remaining>0?money(remaining):'¡Meta alcanzada!';
 if(detail)detail.textContent=remaining>0?'Te faltan '+money(remaining)+' para el envío gratis*':'¡Alcanzaste el monto de envío gratis!*';
 shipping.hidden=(count===0);
 var sticky=document.querySelector('.anita-cart-sticky__total');
 if(sticky)sticky.textContent=money(total);
 var stickyWrap=document.querySelector('.anita-cart-sticky');
 if(stickyWrap)stickyWrap.dataset.empty=count===0?'true':'false';
}
function refresh(){
 document.querySelectorAll('cart-items .cart-item').forEach(makeMeta);
}
var poll=null;
function loadCart(){
 if(poll)clearTimeout(poll);
 poll=setTimeout(function(){
  var root=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
  fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('cart');return r.json()}).then(function(c){updateProgress(c.total_price,c.item_count)}).catch(function(){});
 },150);
}
function stickyCheckout(){
 if(document.querySelector('.anita-cart-sticky'))return;
 var checkout=document.querySelector('#checkout');
 if(!checkout)return;
 var wrap=document.createElement('div');wrap.className='anita-cart-sticky';wrap.dataset.empty='false';
 var total=document.createElement('strong');total.className='anita-cart-sticky__total';
 var price=document.querySelector('.totals__total-value');total.textContent=price?price.textContent.trim():'';
 var button=document.createElement('button');button.className='anita-cart-sticky__button';button.type='submit';button.setAttribute('form','cart');button.setAttribute('name','checkout');
 button.innerHTML='FINALIZAR COMPRA <span aria-hidden="true">→</span>';
 wrap.append(total,button);document.body.appendChild(wrap);
 var enabled=true,originalVisible=true;
 function change(){var active=enabled&&!originalVisible&&!wrap.dataset.empty.includes('true')&&window.scrollY>170;wrap.classList.toggle('is-visible',active)}
 if('IntersectionObserver' in window){var observer=new IntersectionObserver(function(entries){originalVisible=entries[0].isIntersecting;change()},{threshold:.1});observer.observe(checkout)}
 else{originalVisible=false}
 document.addEventListener('scroll',change,{passive:true});
 window.addEventListener('resize',change);
 change();
}
function hideOldShipping(){
 // Turbo Progress Bar sigue activo en páginas de productos; aquí ocultamos solo su recuadro duplicado.
 var main=document.getElementById('MainContent');
 if(!main||!shipping)return;
 var candidates=[];
 main.querySelectorAll('div,section,aside,article').forEach(function(el){
  if(el.hasAttribute('data-anita-hidden-external-shipping')||el.closest('[data-anita-cart-shipping]'))return;
  // Evitar ocultar por accidente el carrito, el título o el bloque de envío propio.
  if(el.querySelector('cart-items,form#cart,.cart__items,[data-anita-cart-shipping],h1.title'))return;
  var content=normalize(el.textContent||'').replace(/\s+/g,' ').trim();
  if(content.length>600||content.length<45)return;
  if(!content.includes('envio por blueexpress a todo chile'))return;
  if(!content.includes('envio gratis en compras desde'))return;
  var box=el.getBoundingClientRect();
  if(box.width<220||box.height<75||box.height>390)return;
  candidates.push({el:el,childCount:el.querySelectorAll('*').length,area:box.width*box.height});
 });
 candidates.sort(function(a,b){return a.childCount-b.childCount||a.area-b.area});
 if(candidates.length){
  var card=candidates[0].el;
  card.setAttribute('data-anita-hidden-external-shipping','true');
  card.style.setProperty('display','none','important');
 }
}
function watchOldShipping(){
 var main=document.getElementById('MainContent');
 if(!main)return;
 var queued=false;
 function schedule(){
  if(queued)return;
  queued=true;
  window.requestAnimationFrame(function(){queued=false;hideOldShipping();});
 }
 var observer=new MutationObserver(function(records){
  if(records.some(function(m){return m.addedNodes&&m.addedNodes.length}))schedule();
 });
 observer.observe(main,{childList:true,subtree:true});
 schedule();
}

function init(){
 refresh();stickyCheckout();hideOldShipping();watchOldShipping();
 if(shipping){var initial=Number(shipping.dataset.anitaTotal);if(isFinite(initial))updateProgress(initial,document.querySelectorAll('cart-items .cart-item').length);}
 var content=document.querySelector('#main-cart-items .js-contents');
 if(content){new MutationObserver(function(m){if(m.some(function(x){return x.type==='childList'})){refresh();loadCart();}}).observe(content,{childList:true});}
 document.addEventListener('shopify:section:load',function(){refresh();loadCart();});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();